/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{resolveCSSVariables as o}from"./css-variables-conversion.js";import{unitConversion as r}from"./unit-conversion.js";const n=(n,t,s,i)=>{const e=o(n,t,i);return t=e.target,i=e.transitionEnd,r(n,t,s,i)};export{n as parseDomVariant};
//# sourceMappingURL=parse-dom-variant.js.map
